// import Vue from "vue";
import { createRouter, createWebHistory } from 'vue-router'
// import store from "../store";

// Public
import MainPage from '@/views/public/Index.vue'
import BlogListPage from '@/views/public/BlogList.vue'
import BlogArticlePage from '@/views/public/BlogArticle.vue'


const routes = [
    {
        path: '/',
        name: 'Main Page',
        name_ru: 'Главная',
        component: MainPage,
        meta: {
            requiresAuth: false,
            gtm: 'blog_home',
            gtmAdditionalEventData: {
                page_type: 'home',
                content_group: 'blog',
            },
            title: 'Aasia Blog',
            title_ru: 'Блог | Aasia',
        }
    },
    {
        path: '/:category/:subcategory/:code',
        name: 'Blog Article',
        component: BlogArticlePage,
        meta: {
            requiresAuth: false,
            gtm: 'blog_article',
            gtmAdditionalEventData: {
                page_type: 'article',
                content_group: 'blog',
            },
            title: 'Статья | Aasia',
            title_ru: 'Статья | Aasia',
        }
    },
    // SYSTEM
    {
        path: '/:pathMatch(.*)*',
        redirect: '/',
        name: 'Not found',
        meta: {
            gtm: 'not_found',
            gtmAdditionalEventData: {
                page_type: 'system',
                content_group: 'error',
            },
            title: 'Not found | Aasia',
            title_ru: 'Страница не найдена | Aasia',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    // base: process.env.BASE_URL,
    mode: 'history',
    routes
})

router.afterEach((to) => {
    if (to.meta?.title_ru) {
        document.title = to.meta.title_ru
    }
})

export default router;